<template>
	<div class="leave-message-image">
		<el-upload
		  class="avatar-uploader"
		  action="="
		  :http-request="uploadEvent"
		  :show-file-list="false"
		  accept="image/png, image/jpg,image/bmp,image/jpeg">
		  <img v-if="$$(source,'url')" :src="$$(source,'url')" class="avatar">
		  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
		</el-upload>
	</div>
</template>

<script>
	import {compressImg} from '@/utils/functions.js';
	
	export default {
		model:{
			prop:'source',
			event:'finish'
		},
		props:{
			source:{
				default:''
				
			}
		},
		methods:{
			async uploadEvent(params){
				if(this.beforeUpload(params.file)){
					let result_files = await compressImg(params.file);
					 const formData = new FormData();
					 formData.append('file', result_files);
					 this.$api.uploadImLeaveMessageFile(formData).then(res => {
						 if(res.errcode != 0) return;
						 this.$emit('finish',{
						 	type:'image',
						 	source:res.data
						 })  
					 })
					 
				}
			},
			beforeUpload(file){
				let uploadType = ['image/png', 'image/jpg','image/bmp','image/jpeg']
				const isTrue = uploadType.includes(file.type);
				const isLimitSize = file.size / 1024 / 1024 < 20;
				if(!isTrue) {
					this.$message.error(`上传只能是${uploadType.join(',')}格式`)
					return false
				}
				if(!isLimitSize) {
					this.$message.error("上传文件大小不能超过20M")
					return false
				}
				return true
			}
		}
	}
</script>

<style lang="scss" scoped>
	.leave-message-image {
		height:100%;
		display: flex;
		justify-content: center;
		align-items: center;
		.avatar-uploader{
			width: 80%;
			height: 100%;
			border: none;
			display: flex;
			justify-content: center;
			align-items: center;
			margin: auto;
			::v-deep {
				.el-upload {
				    border: 1px dashed #d9d9d9;
				    border-radius: 6px;
				    cursor: pointer;
				    position: relative;
				    overflow: hidden;
					&:hover {
						border-color: #409EFF;
					}
				}
			}
		}
	  .avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 178px;
		height: 178px;
		line-height: 178px;
		text-align: center;
	  }
	  .avatar {
		width: 178px;
		height: 178px;
		display: block;
	  }
		 
	}
</style>